import React from 'react';
import { useTranslation } from 'react-i18next';
import { VoiceConnectionType } from '../../services/cxone-sdk.service';
import { VoicePreferenceOption } from './VoicePreferenceOption';
import { PHONE_ICON, SOFTPHONE_ICON, STATION_ICON } from './voice-preference-icons';
import formStyles from './VoicePreferencesForm.module.css';

interface VoicePreferenceOptionsSectionProps {
  selectedType: VoiceConnectionType;
  phoneNumber: string;
  stationId: string;
  isConnecting: boolean;
  onTypeChange: (type: VoiceConnectionType) => void;
  onPhoneNumberChange: (value: string) => void;
  onStationIdChange: (value: string) => void;
}

export function VoicePreferenceOptionsSection({
  selectedType,
  phoneNumber,
  stationId,
  isConnecting,
  onTypeChange,
  onPhoneNumberChange,
  onStationIdChange,
}: VoicePreferenceOptionsSectionProps) {
  const { t } = useTranslation();

  return (
    <div className={formStyles.options}>
      <VoicePreferenceOption
        type="softphone"
        selectedType={selectedType}
        title={t('settings:voice.softphone')}
        description={t('settings:voice.softphoneDesc')}
        iconPath={SOFTPHONE_ICON}
        disabled={isConnecting}
        onSelect={onTypeChange}
      />

      <VoicePreferenceOption
        type="phone"
        selectedType={selectedType}
        title={t('settings:voice.phoneNumber')}
        description={t('settings:voice.phoneNumberDesc')}
        iconPath={PHONE_ICON}
        disabled={isConnecting}
        onSelect={onTypeChange}
      />

      {selectedType === 'phone' && (
        <div className={formStyles.inputContainer}>
          <input
            type="tel"
            placeholder={t('settings:voice.phoneNumberPlaceholder')}
            value={phoneNumber}
            onChange={(e) => onPhoneNumberChange(e.target.value)}
            className={formStyles.textInput}
            disabled={isConnecting}
            autoFocus
          />
        </div>
      )}

      <VoicePreferenceOption
        type="station"
        selectedType={selectedType}
        title={t('settings:voice.stationId')}
        description={t('settings:voice.stationIdDesc')}
        iconPath={STATION_ICON}
        disabled={isConnecting}
        onSelect={onTypeChange}
      />

      {selectedType === 'station' && (
        <div className={formStyles.inputContainer}>
          <input
            type="text"
            placeholder={t('settings:voice.stationIdPlaceholder')}
            value={stationId}
            onChange={(e) => onStationIdChange(e.target.value)}
            className={formStyles.textInput}
            disabled={isConnecting}
            autoFocus
          />
        </div>
      )}
    </div>
  );
}
